import { state } from "@/components/MapGeneration/store/state";
import { LAYER_SETTINGS_TYPES } from "../../constants";
import type { LayerPattern, SettingsPattern } from "..";
import { GtmSvg } from "../icons";
import { GtmTypeSettings } from "./GtmTypeSettings";

export const wellsGtm: LayerPattern = {
	id: "WellsGtm",
	key: "well_gtm",
	title: "Проведенные ГТМ",
	icon: GtmSvg,

	settings: [],

	settingsInit: (): SettingsPattern[] => [
		{
			title: "Привязка к периоду",
			key: "timeBound",
			type: LAYER_SETTINGS_TYPES.BOOLEAN,
			defaultValue: false,
			level: 0,
		},
		{
			title: "Начало периода",
			key: "timeStart",
			type: LAYER_SETTINGS_TYPES.DATE,
			defaultValue: "2000-01-01T00:00:00",
			level: 0,
		},
		{
			title: "Окончание периода",
			key: "timeEnd",
			type: LAYER_SETTINGS_TYPES.DATE,
			defaultValue: new Date().toISOString().split('.')[0] ?? "2022-01-01T00:00:00",
			level: 0,
		},
		{
			title: "Размер (коэфф.)",
			key: "scaleFactor",
			type: LAYER_SETTINGS_TYPES.FLOAT,
			defaultValue: 1.0,
			level: 0,
		},
		{
			title: "gtmTypeSettings",
			key: "gtmTypeSettings",
			type: LAYER_SETTINGS_TYPES.CUSTOM,
			widget: GtmTypeSettings,
			defaultValue: state.gtmTypes.map(({ id, defaultIconId }) => {
				return { gtm_id: id, default: defaultIconId, visible: true };
			}),
			level: 0,
		},
	],
};
